import {Component, OnInit} from '@angular/core';
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Website} from "../../website";
import {combineLatest, Subject} from "rxjs";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {RouteDataService} from "../../../../shared/services/route-data/route-data.service";
import {NavigationEnd, Router} from "@angular/router";

@Component({
    selector: 'db-payment-management',
    templateUrl: './payment-management.component.html',
    styleUrl: './payment-management.component.scss',
    standalone: false
})
export class PaymentManagementComponent implements OnInit {
    public merchantsList;
    public pageId;
    public websites: Website[];
    private readonly _destroyStream$ = new Subject<boolean>();

    constructor(
      private _store: Store<fromStore.DbStoreState>,
      private _router: Router,
      private _routeDataService: RouteDataService,
    ) { }

  ngOnInit() {
      this.pageId = this._routeDataService.getCurrentRouteData().pageId;
      this._router.events
          .pipe(
              filter((event: any) => event instanceof NavigationEnd),
              takeUntil(this._destroyStream$)
          )
          .subscribe(() => {
              this.pageId = this._router && this._router.url.split("/").pop();
          });
      this._mergeData();
    this._store.select(fromStore.getOngoingActivity)
      .pipe(takeUntil(this._destroyStream$), filter(activity => activity?.action === "stripe_account_deactivated" && activity?.status === 'done'))
      .subscribe(activity => {
        this._store.dispatch(new fromStore.LoadEcommerceWorkspaceMerchants);
      });
  }


  private _mergeData(): void {

      this._store.select(fromStore.getWebsitesLoaded)
          .pipe(
              filter(loaded => !!loaded),
              switchMap(() => combineLatest(
                  this._store.select(fromStore.getWebsites),
                  this._store.select(fromStore.getWorkspaceMerchants()),
              )),
              filter(([websites, merchants]) => !!websites && !!merchants)
          )
          .subscribe(([websites, merchants]) => {
              this.merchantsList = merchants?.merchants && merchants?.merchants.filter(merchant => merchant?.env === 'live' && merchant?.merchantStatus !== 'deauthorized' && merchant?.active);
              this.websites = websites;
              this.merchantsList?.length && this._mapArrays(this.merchantsList, websites);
          });
  }

  private _mapArrays(merchants, websites): void {
      return merchants.map((e, i) => {
          let temp = websites && websites.find(website => e?.websiteId === website?.id);
          if (TypeUtils.isDefined(temp) && temp?.site_url) {
              e.siteUrl = temp?.site_url;
          }
          else {
            e.siteUrl = '-';
          }
          return e;
      });
  }

}
